import React from "react";

import user_upload_image from "../../assets/images/User.png";
import upload_icon from "../../assets/images/upload_icon.svg";

import { useState, useEffect, useRef } from "react";

import { useDispatch } from "react-redux";

import {
  fetchCountries,
  fetchStates,
  fetchCities,
} from "../../store/slices/locationSlice";

function EditPresnolDetail({
  clientData,
  onDataChange,
  countries = [],
  states = [],
  cities = [],
  onOpenLocationPopup,
}) {
  const dispatch = useDispatch();

  const [phoneError, setPhoneError] = useState("");

  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  const fileInputRef = useRef(null);

  const [previewUrl, setPreviewUrl] = useState(null);

  const validatePhoneNumber = (value) => {
    if (!value) return false;

    const phoneRegex = /^\d{10}$/;

    return phoneRegex.test(String(value).trim());
  };

  const handleChange = (field, value) => {
    if (field === "phone") {
      const sanitizedValue = value.replace(/\D/g, "").slice(0, 10);

      if (sanitizedValue && !validatePhoneNumber(sanitizedValue)) {
        setPhoneError("Phone number must be exactly 10 digits");
      } else {
        setPhoneError("");
      }

      onDataChange({
        [field]: sanitizedValue,
      });
    } else {
      onDataChange({
        [field]: value,
      });
    }
  };

  // Display the phone as clean, editable digits (strip any formatting from stored value)
  const getDisplayPhone = () => {
    if (clientData?.phone === null || clientData?.phone === undefined)
      return "";

    return String(clientData.phone).replace(/\D/g, "").slice(0, 10);
  };

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const url = URL.createObjectURL(file);

      setPreviewUrl(url);

      onDataChange({
        file,
      });
    }
  };

  // FETCH COUNTRIES
  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  // FETCH STATES
  useEffect(() => {
    const countryId = clientData?.countryId || clientData?.CountryId;

    if (countryId) {
      dispatch(fetchStates(countryId));
    }
  }, [clientData?.countryId, clientData?.CountryId, dispatch]);

  // FETCH CITIES
  useEffect(() => {
    const stateId = clientData?.stateId || clientData?.StateId;

    if (stateId) {
      dispatch(fetchCities(stateId));
    }
  }, [clientData?.stateId, clientData?.StateId, dispatch]);

  return (
    <div className="editpresoldetail mb_20">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="white_card">
              <div className="col-md-12">
                <h4>Personal Details</h4>
              </div>

              <div className="row">
                {/* IMAGE */}
                <div className="col-md-2">
                  <div className="user_image_upload mt_24">
                    <img
                      src={
                        previewUrl ||
                        (clientData?.profile
                          ? BASE_URL + clientData.profile
                          : user_upload_image)
                      }
                      alt="profile"
                    />

                    <button
                      type="button"
                      className="upload_btn"
                      onClick={handleFileUpload}
                    >
                      <img src={upload_icon} alt="upload" />
                    </button>

                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{
                        display: "none",
                      }}
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>

                  <h5 className="user_name mt_18">
                    {clientData?.name || "Client Name"}
                  </h5>
                </div>

                {/* LEFT */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    <div className="form_group">
                      <label>Name</label>

                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Client Name"
                        value={clientData?.name || ""}
                        onChange={(e) => handleChange("name", e.target.value)}
                      />
                    </div>

                    <div
                      className={`form_group ${
                        phoneError ? "input-error" : ""
                      }`}
                    >
                      <label>Phone Number</label>

                      <input
                        type="tel"
                        className="form-control pl_16"
                        placeholder="Phone Number"
                        value={getDisplayPhone()}
                        maxLength={10}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onChange={(e) => handleChange("phone", e.target.value)}
                      />

                      {phoneError && (
                        <div
                          className="error-message"
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          {phoneError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* RIGHT */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    <div className="form_group">
                      <label>Email Address</label>

                      <input
                        type="email"
                        className="form-control pl_16"
                        placeholder="Email Address"
                        value={clientData?.email || ""}
                        name="email"
                        onChange={(e) => handleChange("email", e.target.value)}
                      />
                    </div>

                    <div className="form_group">
                      <label>Address</label>

                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Address"
                        value={
                          clientData?.addressLine ||
                          clientData?.addressLine1 ||
                          clientData?.address ||
                          ""
                        }
                        onChange={(e) => {
                          // Update both addressLine (company) and addressLine1 (client/employee/profile)
                          onDataChange({
                            addressLine: e.target.value,
                            addressLine1: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* LOCATION */}
              <div className="row">
                <div className="col-md-2"></div>

                {/* LEFT */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    {/* COUNTRY */}
                    <div className="form_group">
                      <label>Country</label>

                      <select
                        className="form-control pl_16"
                        value={String(
                          clientData?.countryId || clientData?.CountryId || "",
                        )}
                        onChange={(e) => {
                          const value = e.target.value;

                          // ADD NEW
                          if (value === "__add_new__") {
                            if (typeof onOpenLocationPopup === "function") {
                              onOpenLocationPopup("country");
                            }

                            return;
                          }

                          const selectedCountry = countries?.find(
                            (c) => String(c.id) === String(value),
                          );

                          onDataChange?.({
                            countryId: value,
                            CountryId: value,

                            country: selectedCountry?.name || "",

                            stateId: "",
                            StateId: "",
                            state: "",

                            cityId: "",
                            CityId: "",
                            city: "",
                          });

                          dispatch(fetchStates(value));
                        }}
                      >
                        <option value="">Select Country</option>

                        {countries?.map((c) => (
                          <option key={c.id} value={String(c.id)}>
                            {c.name}
                          </option>
                        ))}

                        <option value="__add_new__">+ Add new country</option>
                      </select>
                    </div>

                    {/* STATE */}
                    <div className="form_group">
                      <label>State</label>

                      <select
                        className="form-control pl_16"
                        value={String(
                          clientData?.stateId || clientData?.StateId || "",
                        )}
                        disabled={
                          !(clientData?.countryId || clientData?.CountryId)
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          // ADD NEW
                          if (value === "__add_new__") {
                            if (typeof onOpenLocationPopup === "function") {
                              onOpenLocationPopup("state", {
                                countryId:
                                  clientData?.countryId ||
                                  clientData?.CountryId ||
                                  "",
                              });
                            }

                            return;
                          }

                          const selectedState = states?.find(
                            (s) => String(s.id) === String(value),
                          );

                          onDataChange?.({
                            stateId: value,
                            StateId: value,

                            state: selectedState?.name || "",

                            cityId: "",
                            CityId: "",
                            city: "",
                          });

                          dispatch(fetchCities(value));
                        }}
                      >
                        <option value="">Select State</option>

                        {states?.map((s) => (
                          <option key={s.id} value={String(s.id)}>
                            {s.name}
                          </option>
                        ))}

                        <option value="__add_new__">+ Add new state</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* RIGHT */}
                <div className="col-md-5">
                  <div className="common_input_forms">
                    {/* CITY */}
                    <div className="form_group">
                      <label>City</label>

                      <select
                        className="form-control pl_16"
                        value={String(
                          clientData?.cityId || clientData?.CityId || "",
                        )}
                        disabled={!(clientData?.stateId || clientData?.StateId)}
                        onChange={(e) => {
                          const value = e.target.value;

                          // ADD NEW
                          if (value === "__add_new__") {
                            if (typeof onOpenLocationPopup === "function") {
                              onOpenLocationPopup("city", {
                                stateId:
                                  clientData?.stateId ||
                                  clientData?.StateId ||
                                  "",
                              });
                            }

                            return;
                          }

                          const selectedCity = cities?.find(
                            (c) => String(c.id) === String(value),
                          );

                          onDataChange?.({
                            cityId: value,
                            CityId: value,

                            city: selectedCity?.name || "",
                          });
                        }}
                      >
                        <option value="">Select City</option>

                        {cities?.map((c) => (
                          <option key={c.id} value={String(c.id)}>
                            {c.name}
                          </option>
                        ))}

                        <option value="__add_new__">+ Add new city</option>
                      </select>
                    </div>

                    {/* ZIP */}
                    <div className="form_group">
                      <label>ZIP Code</label>

                      <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="ZIP Code"
                        value={clientData?.postalCode || ""}
                        onChange={(e) =>
                          handleChange("postalCode", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditPresnolDetail;
